import { injectable } from 'tsyringe'
import { GuideMaterialApiRepository } from '@/app/repositories/api/GuideMaterialRepository'
import { GuideMaterial } from '@/domain/entities/QuickGuideMaterial'
import {
  PostGuideMaterialInterface,
  DeleteGuideMaterialInterface,
  UpdateGuideMaterialInterface,
} from '@/data/payload/contracts/GuideMaterialRequest'
@injectable()
export class GuideMaterialPresenter {
  private repository: GuideMaterialApiRepository

  constructor(repository: GuideMaterialApiRepository) {
    this.repository = repository
  }

  public loadGuideMaterial(params: Object): Promise<GuideMaterial> {
    return this.repository.getAll(params)
  }

  public postGuideMaterial(
    payload: PostGuideMaterialInterface
  ): Promise<GuideMaterial> {
    return this.repository.post(payload)
  }

  public updateGuideMaterial(
    payload: UpdateGuideMaterialInterface,
    id: number
  ): Promise<GuideMaterial> {
    return this.repository.update(payload, id)
  }

  public deleteGuideMaterial(
    payload: DeleteGuideMaterialInterface
  ): Promise<GuideMaterial> {
    return this.repository.delete(payload)
  }
}
